import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "1219",
  height: "877",
  viewBox: "0 0 1219 877",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M497 1.5L3 250.5L1218.5 875.5",
      stroke: "url(#paint0_linear_8_465)",
      "stroke-opacity": "0.32",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "paint0_linear_8_465",
        x1: "2113.74",
        y1: "-1326.15",
        x2: "-1034.44",
        y2: "1795.93",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", {
          "stop-color": "#001A78",
          "stop-opacity": "0"
        }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#596294"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }